import { Tooltip } from '@design-system/components/tooltip/tooltip';
import { Typography } from '@design-system/components/typography/typography';
import { Stack, TableCell } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/pro-regular-svg-icons';

type HeaderTableCellProps = {
  title: string;
  align: 'left' | 'right';
  tooltip?: string;
};

export const HeaderTableCell: React.FC<HeaderTableCellProps> = ({
  title,
  align,
  tooltip,
}) => (
  <TableCell
    align={align}
    className={'px-4 py-2 w-52 text-black'}
    sx={{
      '&:first-of-type': { borderRadius: '10px 0 0 0' },
      '&:last-of-type': { borderRadius: ' 0 10px 0 0' },
    }}
  >
    <Stack
      direction="row"
      spacing={1}
      justifyContent={align}
      alignItems="center"
    >
      <Typography variant="body" size="large">
        {title}
      </Typography>
      {tooltip && (
        <Tooltip
          title={tooltip}
          variant="dark"
          arrow={false}
          tooltipProps={{ maxWidth: '400px', padding: '16px' }}
        >
          <FontAwesomeIcon icon={faCircleInfo} className="cursor-pointer" />
        </Tooltip>
      )}
    </Stack>
  </TableCell>
);
